import fetchJsonp from 'fetch-jsonp';
import dayjs from 'dayjs';

const formatTime = num => {
  num = parseInt(num, 10);
  return num < 10 ? `0${num}` : `${num}`;
};

const calcLeftTimes = leftTime => {
  let days = formatTime(leftTime / 1000 / 60 / 60 / 24); // 计算剩余的天数
  let hours = formatTime((leftTime / 1000 / 60 / 60) % 24); // 计算剩余的小时
  let minutes = formatTime((leftTime / 1000 / 60) % 60); // 计算剩余的分钟
  let seconds = formatTime((leftTime / 1000) % 60); // 计算剩余的秒数
  return {
    days,
    hours,
    minutes,
    seconds,
    leftTime,
  };
};

export default class Time {
  /**
   * 获取当前时间时间戳
   * @return {Promise} 请求结果
   */
  static getTimeStamp() {
    return fetchJsonp('https://page.aliyun.com/common/getTimestamp')
      .then(res => res.json())
      .then(json => (json.code === '200' ? json.data * 1000 : Promise.reject(json)))
      .catch(error => {
        if (error && error.code) {
          throw new Error(`${error.code}:${error.msg}`);
        } else {
          throw new Error(`时间接口请求错误，请检查${error}`);
        }
      });
  }

  static async getCurrentTime() {
    try {
      const result = await Time.getTimeStamp();
      // result 为 undefined 时 dayjs 取当前客户端时间
      return dayjs(result);
    } catch (error) {
      throw new Error(error);
    }
  }

  static async isAfter(targetTime) {
    const currentTime = await Time.getCurrentTime();
    return currentTime.isAfter(dayjs(targetTime));
  }

  /**
   * 定时器
   *
   * @static
   * @param {Object} { targetTime, end } 目标时间，到达目标时间后的回调函数
   * @return {Boolean} 调用时是否已到达目标时间
   * @memberof Time
   */
  static async timer({ targetTime, callback }) {
    let tempTimer;
    try {
      targetTime = dayjs(targetTime);
      const currentTime = await Time.getCurrentTime();
      const hasArrived = targetTime.isBefore(currentTime);
      if (hasArrived) {
        return callback && callback();
      } else {
        const diffResult = targetTime.diff(currentTime, 'minutes', true);
        // 超过五分钟后，到五分钟时再重新调用 timer
        if (diffResult > 5) {
          setTimeout(() => {
            Time.timer({ targetTime: targetTime.unix() * 1000, callback });
          }, (diffResult - 5) * 60 * 1000);
        }
        // 五分钟内每分钟轮询一次
        if (diffResult > 0 && diffResult <= 5) {
          tempTimer = setInterval(async () => {
            const currentTime = await Time.getCurrentTime();
            const hasArrived = targetTime.isBefore(currentTime);
            if (hasArrived) {
              clearInterval(tempTimer);
              return callback && callback();
            }
          }, 60000);
        }
      }
      return hasArrived;
    } catch (error) {
      clearInterval(tempTimer);
      console.error(error);
    }
  }

  /**
   * 倒计时
   *
   * @static
   * @param {Object} { targetTime, tick, end } 目标时间，每一秒倒计时触发的回调，结束倒计时的回调
   * @return {null} none
   * @memberof Time
   */
  static async countdown({ targetTime, tick, end }) {
    let tempTimer;
    try {
      targetTime = dayjs(targetTime);
      const currentTime = await Time.getCurrentTime();
      let leftTime = targetTime.diff(currentTime, 'second', true) * 1000;
      // leftTime > 0 意味着还未到目标时间，则继续倒计时并触发tick
      // leftTime <= 0 意味着目标时间已过，则触发 end
      if (leftTime <= 0) return end && end();
      // 触发第一次倒计时
      tick && tick(calcLeftTimes(leftTime));
      tempTimer = setInterval(() => {
        leftTime = leftTime - 1000;
        if (leftTime <= 0) {
          clearInterval(tempTimer);
          return end && end();
        }
        const leftTimes = calcLeftTimes(leftTime);
        tick && tick(leftTimes);
      }, 1000);
    } catch (error) {
      clearInterval(tempTimer);
      console.error(error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/time.js